import { GetMkplTopItemsParams } from '@/types/mkpl/top-items';
import { VendorTypeEnum } from '@/constants/mkpl';
import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * 获取商家介绍信息
 * @param params
 * @param config
 */
export const getVendorIntroduction = (
  params: {
    vendorId: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/vendor/seller/introduction/${params?.vendorId}`, {}, config);
};

/**
 * 获取商家介绍信息
 * @param params
 * @param config
 */
export const getVendorHomepageInfo = (
  params: {
    vendorId: number;
    mode?: string;
    biz_type?: 'seller' | 'fbw';
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  const { vendorId, ...restParams } = params ?? {};
  return fetch.get(`/ec/marketplace/vendor/seller/homepage/${vendorId}`, restParams, config);
};

/**
 * 获取商家介绍信息没有ab
 * @param params
 * @param config
 */
export const getVendorHomepageInfoV2 = (
  params: {
    vendorId: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/vendor/sellers/${params?.vendorId}`, {}, config);
};

export const getVendorLightingDealsData = (
  params: {
    vendor_id: number | string;
    biz_type: VendorTypeEnum;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/lightning/carousel`, params, config);
};

export const getMkplLightingDealsData = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/lightning/carousel`, {}, config);
};

/*
 * 获取global filter
 * @param params
 * @param config
 */
export const getGlobalFilter = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/marketplace/global/origin/list', {}, config);
};

/**
 * 获取global all stores
 * @param params
 * @param config
 */
export const getGlobalAllStores = (url, params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(url, {}, config);
};

/**
 * 获取global introducing
 * @param params
 * @param config
 */
export const getGlobalIntroducing = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/global/introduction`, {}, config);
};

/**
 * 获取product filter 中 global+的介绍
 * @param params
 * @param config
 */
export const getFilterGlobalIntroducing = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/global/filter/introduction`, {}, config);
};

/**
 * 查询商铺详细信息
 */
export const getVendorDetail = (vendorId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/vendor/seller/store/detail/${vendorId}`, {}, config);
};
/**
 * feekback列表
 */
export const getFeedbackList = (vendorId, params = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/social/seller/${vendorId}/feedback`, params, config);
};
/**
 * 关注/取消关注
 */
export const changeFollowStatus = (data = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/social/seller/follow', data, config);
};

/**
 * 获取mkpl coupon landing数据
 */
export const getMkplcouponLanding = (params = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/marketplace/global/welcome/coupons', params, config);
};

/**
 * 领取seller coupon
 */
export const claimSellerCoupon = (sellerId, params = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/marketplace/coupons/sellers/${sellerId}`, params, config);
};

/**
 * 获取mkpl coupon landing数据
 */
export const getMkplLightningLanding = (params = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/marketplace/lightning/landing', params, config);
};

type GetMkplAllStoreRequestParams = {
  origin_ids: number;
  lang: string;
  date: string;
  pagesize: number;
  page_no: number;
};

export const getMkplAllStore = (
  params: GetMkplAllStoreRequestParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/marketplace/global/store/all', params, config);
};

export const getMkpTrendingStore = (
  params: { zipcode: string | number; limit?: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/marketplace/global/store/trending/list', params, config);
};

export const getMkplTopItems = (params: GetMkplTopItemsParams, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  const timestamp = Math.floor(new Date().getTime() / 1000);
  return fetch.get('/ec/marketplace/global/ranking/top/feed', { ...params, timestamp }, config);
};
